import {Component, Input} from '@angular/core';
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-breadcrumb-mkt',
  standalone: true,
    imports: [
        RouterLink
    ],
  templateUrl: './breadcrumb-mkt.component.html',
  // styleUrl: './breadcrumb-mkt.component.css'
})
export class BreadcrumbMktComponent {
  @Input() title: string = '';  // Parámetro dinámico
  @Input() routeBase: string = '';


}
